export interface ChartDataPoint {
  name: string;
  value?: number;
  [key: string]: string | number | undefined;
}

export interface ChartSeries {
  dataKey: string;
  name: string;
  color: string;
  type?: 'monotone' | 'linear' | 'step';
}

export interface ChartProps {
  data: ChartDataPoint[];
  height?: number;
  loading?: boolean;
  className?: string;
}

export const CHART_COLORS = {
  primary: '#3b82f6', // blue-500
  success: '#22c55e', // green-500
  warning: '#f59e0b', // amber-500
  danger: '#ef4444', // red-500
  purple: '#a855f7', // purple-500
  cyan: '#06b6d4', // cyan-500
  gray: '#6b7280', // gray-500
} as const;

export const CHART_COLOR_PALETTE = [
  CHART_COLORS.primary,
  CHART_COLORS.success,
  CHART_COLORS.warning,
  CHART_COLORS.danger,
  CHART_COLORS.purple,
  CHART_COLORS.cyan,
];
